/*
 * LOB pagina
 */
jQuery( function( $ ) {
  // Form modal
  $(document.body)
    .on('click', '#OpenLobFormModal1', function (e) {
      e.preventDefault();
      $('#LobFormModal1')
        .modal('show');
    });
  $(document.body)
    .on('click', '#OpenLobFormModal2', function (e) {
      e.preventDefault();
      $('#LobFormModal2')
        .modal('show');
    });
});
